export default "__VITE_ASSET__DZ7V1JWa__"